module.exports = __webpack_public_path__ + "img/aggregate-line-short.cf0a8da8.svg";